import { z } from "zod";

// TES-363 — admin reviewability: the bulk-import batch history.
//
// Each POST employee-api/v1/import(/csv) batch writes ONE batch-level audit row
// (action `import.bulk`, see bulk-import.service.ts) whose metadata carries the
// results SUMMARY: { format, mode, total, created, updated, failed }. That is
// deliberately PHI-free and COUNTS-ONLY — the audit metadata does NOT retain
// the per-item results array (per-entity audit rows carry the granular trail),
// so this read model exposes what actually exists: when, who, and the counts.
// Kept in its own module (not bulk-import.ts) so the import wire contract and
// this reviewability read model can evolve independently.

export const importHistoryBatchSchema = z.object({
  // The audit row id — a stable React key for the admin list.
  id: z.string(),
  // ISO datetime the batch ran (audit occurredAt).
  when: z.string(),
  // The importing doctor's employee id (audit actorId). Null only for
  // hypothetical system-driven imports.
  actorId: z.string().nullable(),
  // `json` | `csv` — best-effort from metadata (older rows may lack it).
  format: z.string().nullable(),
  // `create` | `replace` (TES-349) — best-effort from metadata.
  mode: z.string().nullable(),
  summary: z.object({
    total: z.number().int().nonnegative(),
    created: z.number().int().nonnegative(),
    updated: z.number().int().nonnegative(),
    failed: z.number().int().nonnegative(),
  }),
});
export type ImportHistoryBatch = z.infer<typeof importHistoryBatchSchema>;

// GET employee-api/v1/import/history — the last ~50 batches, newest first.
export const importHistoryResponseSchema = z.object({
  batches: z.array(importHistoryBatchSchema),
});
export type ImportHistoryResponse = z.infer<typeof importHistoryResponseSchema>;
